import { render, staticRenderFns } from "./btn-text-quarternary2.vue?vue&type=template&id=3c2f5e86&scoped=true"
import script from "./btn-text-quarternary2.vue?vue&type=script&lang=js"
export * from "./btn-text-quarternary2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f5e86",
  null
  
)

export default component.exports